import { Injectable } from '@angular/core';
import { GrowthBook } from '@growthbook/growthbook';
import { autoAttributesPlugin } from '@growthbook/growthbook/plugins';
import { BehaviorSubject } from 'rxjs';
import { FeatureFlag } from '../common/feature-flags/feature-flags';
import { environment } from 'environment';
import { AppConstants } from '../common/constants/app-constants';

@Injectable({ providedIn: 'root' })
export class GrowthBookService {
  private gb!: GrowthBook;
  private ready = false;
  userReady$ = new BehaviorSubject(false);

  async init() {
    this.gb = new GrowthBook({
      apiHost: environment.growthbook.apiHost,
      clientKey: environment.growthbook.clientKey,
      enableDevMode: environment.growthbook.enableDevMode,
      trackingCallback: (experiment, result) => {
        console.log(AppConstants.viewedExperiment, {
          experimentId: experiment.key,
          variationId: result.key
        });
      },
      plugins: [autoAttributesPlugin()]
    });

    await this.gb.init({ streaming: true });
    this.ready = true;
  }

  setAttributes(attributes: Record<string, any>) {
    if (!this.gb) return;
    this.gb.setAttributes(attributes);
  }

  getAttributes() {
    return this.gb?.getAttributes() ?? {};
  }

  isOn(flag: FeatureFlag): boolean {
    if (!this.ready) return false;
    return this.gb.isOn(flag);
  }

  getFeatureValue<T>(key: string, defaultValue: T): T {
    if (!this.ready) return defaultValue;
    return this.gb.getFeatureValue(key, defaultValue) as T;
  }
}